// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/source/api/source.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_source_resources_source } from "../resources/source_pb.js";
import { file_services_source_resources_source_configuration_source_configuration } from "../resources/source_configuration/source_configuration_pb.js";
import { file_services_source_resources_source_registry } from "../resources/source_registry_pb.js";
import { file_services_source_resources_source_sync } from "../resources/source_sync_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";
import { file_shared_sorting } from "../../../shared/sorting_pb.js";

/**
 * Describes the file services/source/api/source.proto.
 */
export const file_services_source_api_source = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_services_database_models_public, file_services_source_resources_source, file_services_source_resources_source_configuration_source_configuration, file_services_source_resources_source_registry, file_services_source_resources_source_sync, file_shared_pagination, file_shared_sorting]);

/**
 * Describes the message gx.source.api.SourceConfigurationResponse.
 * Use `create(SourceConfigurationResponseSchema)` to create a new message.
 */
export const SourceConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 0);

/**
 * Describes the message gx.source.api.WebhookConfigurationDetails.
 * Use `create(WebhookConfigurationDetailsSchema)` to create a new message.
 */
export const WebhookConfigurationDetailsSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 1);

/**
 * Describes the message gx.source.api.BrowserbaseConfigurationDetails.
 * Use `create(BrowserbaseConfigurationDetailsSchema)` to create a new message.
 */
export const BrowserbaseConfigurationDetailsSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 2);

/**
 * Describes the message gx.source.api.CreateSourceRequest.
 * Use `create(CreateSourceRequestSchema)` to create a new message.
 */
export const CreateSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 3);

/**
 * Describes the message gx.source.api.CreateSourceResponse.
 * Use `create(CreateSourceResponseSchema)` to create a new message.
 */
export const CreateSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 4);

/**
 * Describes the message gx.source.api.GetSourceRequest.
 * Use `create(GetSourceRequestSchema)` to create a new message.
 */
export const GetSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 5);

/**
 * Describes the message gx.source.api.GetSourceResponse.
 * Use `create(GetSourceResponseSchema)` to create a new message.
 */
export const GetSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 6);

/**
 * Describes the message gx.source.api.SourceFilter.
 * Use `create(SourceFilterSchema)` to create a new message.
 */
export const SourceFilterSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 7);

/**
 * Describes the message gx.source.api.ListSourcesRequest.
 * Use `create(ListSourcesRequestSchema)` to create a new message.
 */
export const ListSourcesRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 8);

/**
 * Describes the message gx.source.api.ListSourcesResponse.
 * Use `create(ListSourcesResponseSchema)` to create a new message.
 */
export const ListSourcesResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 9);

/**
 * Describes the message gx.source.api.UpdateSourceRequest.
 * Use `create(UpdateSourceRequestSchema)` to create a new message.
 */
export const UpdateSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 10);

/**
 * Describes the message gx.source.api.UpdateSourceResponse.
 * Use `create(UpdateSourceResponseSchema)` to create a new message.
 */
export const UpdateSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 11);

/**
 * Describes the message gx.source.api.DeleteSourceRequest.
 * Use `create(DeleteSourceRequestSchema)` to create a new message.
 */
export const DeleteSourceRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 12);

/**
 * Describes the message gx.source.api.DeleteSourceResponse.
 * Use `create(DeleteSourceResponseSchema)` to create a new message.
 */
export const DeleteSourceResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 13);

/**
 * Describes the message gx.source.api.GetPresignedDownloadUriRequest.
 * Use `create(GetPresignedDownloadUriRequestSchema)` to create a new message.
 */
export const GetPresignedDownloadUriRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 14);

/**
 * Describes the message gx.source.api.GetPresignedDownloadUriResponse.
 * Use `create(GetPresignedDownloadUriResponseSchema)` to create a new message.
 */
export const GetPresignedDownloadUriResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 15);

/**
 * Describes the message gx.source.api.SourceIngestionUsage.
 * Use `create(SourceIngestionUsageSchema)` to create a new message.
 */
export const SourceIngestionUsageSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 16);

/**
 * Describes the message gx.source.api.GetTenantSourceUsageRequest.
 * Use `create(GetTenantSourceUsageRequestSchema)` to create a new message.
 */
export const GetTenantSourceUsageRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 17);

/**
 * Describes the message gx.source.api.GetTenantSourceUsageResponse.
 * Use `create(GetTenantSourceUsageResponseSchema)` to create a new message.
 */
export const GetTenantSourceUsageResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 18);

/**
 * Describes the message gx.source.api.GetSourceUsageRequest.
 * Use `create(GetSourceUsageRequestSchema)` to create a new message.
 */
export const GetSourceUsageRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 19);

/**
 * Describes the message gx.source.api.GetSourceUsageResponse.
 * Use `create(GetSourceUsageResponseSchema)` to create a new message.
 */
export const GetSourceUsageResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 20);

/**
 * Describes the message gx.source.api.GetSourceWithCredentialsRequest.
 * Use `create(GetSourceWithCredentialsRequestSchema)` to create a new message.
 */
export const GetSourceWithCredentialsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 21);

/**
 * Describes the message gx.source.api.GetSourceWithCredentialsResponse.
 * Use `create(GetSourceWithCredentialsResponseSchema)` to create a new message.
 */
export const GetSourceWithCredentialsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source, 22);

/**
 * @generated from service gx.source.api.SourceService
 */
export const SourceService = /*@__PURE__*/
  serviceDesc(file_services_source_api_source, 0);

